import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { Emitter } from '@patsnap/tahiti-core';
import { EurekaAmountsControlApi } from '@telecom/shared/domain/permission/apis/eureka-amounts-control-api';
import type { EurekaAmountsControl } from '@telecom/shared/domain/permission/apis/eureka-amounts-control-api';
import { EurekaAmountsControlService } from '../eureka-amounts-control-service';

/**
 * Eureka 权益控制服务实现
 */
@injectable()
export class EurekaAmountsControlServiceImpl extends EurekaAmountsControlService {
    private _amountsControl: EurekaAmountsControl | null = null;
    private _isLoading = false;
    private _syncPromise: Promise<void> | null = null;
    private _onAmountsControlChangeEmitter = new Emitter<void>();

    readonly onAmountsControlChange = this._onAmountsControlChangeEmitter.event;

    constructor(
        @inject(EurekaAmountsControlApi)
        private readonly _eurekaAmountsControlApi: EurekaAmountsControlApi,
    ) {
        super();
    }

    getAmountsControl(): EurekaAmountsControl | null {
        return this._amountsControl;
    }

    isLoading(): boolean {
        return this._isLoading;
    }

    isFreeUser(): boolean {
        return this._amountsControl?.freemium === true;
    }

    hasCreditPackage(): boolean {
        return this._amountsControl?.credit_package === true;
    }

    syncAmountsControl(): Promise<void> {
        if (this._syncPromise) {
            return this._syncPromise;
        }

        this._isLoading = true;
        this._syncPromise = this._eurekaAmountsControlApi.getAmountsControl()
            .then((control) => {
                this._amountsControl = control || null;
            })
            .catch((error) => {
                this._amountsControl = null;
                console.error('Failed to load eureka amounts control:', error);
            })
            .finally(() => {
                this._isLoading = false;
                this._syncPromise = null;
                this._onAmountsControlChangeEmitter.fire();
            });

        return this._syncPromise;
    }

    async ensureLoaded(): Promise<void> {
        if (this._amountsControl) {
            return;
        }
        await this.syncAmountsControl();
    }
}
